<template>
  <div>
    <common :dataSource='dataSource' :type="1" surveyNoPrefix="Student-"></common>
  </div>
</template>
<script>
import common from './common.vue'
export default {
  components: {
    common
  },
  methods: {

  },
  data() {
    return {
      dataSource: [
        [
          {
            type: 1,
          },
          {
            type: 3,
            title: '以下题目是了解个人特征的调查，请你仔细阅读每一道题，根据自己的实际情况，做出判断并点击对应的选项。'
          },
          {
            type: 2,
            headline: '1.在学校里，我喜欢试着对事情或问题做出猜测，即使不一定都猜对也无所谓。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '2.我喜欢仔细观察没有见过的东西。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '3.我喜欢变化多端和富有想象力的故事。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '4.我喜欢幻想一些想知道或想做的事。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '5.如果事情不能一次完成，我会继续尝试，直到完成为止。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '6.做功课时我喜欢参考各种不同的资料，以便得到多方面的了解。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '7.我喜欢用熟悉的方法做事情，不喜欢去找其他新的方法。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '8.我喜欢探究事情的真相。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '9.我喜欢做许多新鲜的事。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '10.我不喜欢结交新朋友。',
            value: [
              '不符合', '部分符合', '完全符合'
            ]
          },
          {
            type: 2,
            headline: '11.我喜欢想一些不会在我身上发生的事。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '12.我喜欢想象有一天能成为艺术家、音乐家或诗人。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '13.我会因为一些令人兴奋的念头而忘了其他的事。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '14.我认为所有的问题都有明确的答案。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '15.我喜欢与众不同的事情。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '16.我常想要知道别人在想什么。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '17.我喜欢故事或电视节目所讲的事。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '18.我长大以后，想做一些别人从没想过的事。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '19.我认为尝试新的游戏和活动是一件有趣的事。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '20.我不喜欢受太多规则限制。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '21.我喜欢解决问题，即使没有正确答案也没关系。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '22.有许多事情我都很想亲自去尝试。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '23.我喜欢唱没有人知道的歌。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '24.我不喜欢在班上同学面前发表意见。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '25.当我读小说或看电视时，我喜欢把自己想成故事中的人物。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '26.我喜欢幻想200年前人类生活的情形。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '27.我常想自己编一首新歌。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '28.我总喜欢先猜猜看，再看是不是猜对了，这种方法很有趣。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '29.我认为玩猜谜之类的游戏很有趣。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '30.我喜欢可以拆开来玩的玩具。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '31.我喜欢想一些新点子，即使用不着也无所谓。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '32.我喜欢尝试新的事物，目的只是为了想知道会有什么结果。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '33.玩游戏时，我通常是有兴趣参加，而不在乎输赢。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '34.我看到一张陌生人的照片时，喜欢去猜测他是怎么样的一个人。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '35.我喜欢翻阅书籍及杂志，了解其大概内容。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '36.我不喜欢探寻事情发生了什么问题。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '37.我喜欢问一些别人没有想到的问题。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
          {
            type: 2,
            headline: '38.无论在家里还是在学校，我总喜欢做许多有趣的事。',
            value: [ '不符合', '部分符合', '完全符合' ]
          },
        ],
        [
          {
            type: 3,
            title: '下面是一些关于个人特征的描述，请你仔细阅读每一道题，根据自己的实际情况，做出判断并点击对应的选项。'
          },
          {
            type: 2,
            headline: '1. 我是一个从容，善于处理压力的人。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '2. 我是一个对艺术没有什么兴趣的人。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '3. 我是一个经历挫折后仍能保持积极心态的人。 ',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '4. 我是一个善于创造，能找到聪明的方法来做事的人。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '5. 我是一个容易紧张的人。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '6. 我是一个有安全感，对自己满意的人。  ',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '7. 我是一个情绪稳定，不易生气的人。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '8. 我是一个几乎没有什么创造性的人。 ',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '9. 我是一个时常小心翼翼，担心做错事的人。 ',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '10. 我是一个思想深刻的人。  ',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '11. 我是一个能够控制自己的情绪的人。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '12. 我是一个缺乏想象力的人。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '13. 我是一个很少觉得焦虑或者害怕的人。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '14. 我觉得诗歌、戏剧很无聊。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '15. 我对抽象的概念和想法没什么兴趣。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
          {
            type: 2,
            headline: '16. 我是一个有创意，能想出新点子的人。',
            value: [
              '非常不同意', '不太同意', '态度中立', '比较同意', '非常同意'
            ]
          },
        ],
        [
          {
            type: 3,
            title: '以下是小学科学/中学物理、化学、生物、通用技术、综合实践老师课堂教学行为的描述，请你仔细阅读每一道题，根据自己的感受，做出判断并点击对应的选项。'
          },
          {
            type: 2,
            headline: '1.课上，我们有机会交流看法和观点。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '2.当我们提出某些观点时，老师不着急评判，而是鼓励我们进一步思考。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '3.老师能深入细致地了解我们的建议，认真对待我们的建议。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '4.我们在课上会经常进行小组活动。 ',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '5.老师为我们提供机会了解彼此的优缺点。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '6.老师赞赏我们将所学知识派上不同的用场。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '7.老师给我们布置独立解决的问题。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '8.老师鼓励我们为教学出谋划策。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '9.老师鼓励我们从不同的角度思考，哪怕其想法可能行不通。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '10.我们知道老师不会轻易否定我们的建议。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '11.老师鼓励我们用课上所学的知识做不同的事情。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '12.老师帮助我们从失败中吸取教训。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '13.老师教给我们基础知识并给我们留出个人自学的时间。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '14.老师只在我们充分讨论看法后才发表评论。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '15.老师喜欢我们花时间从不同的方面进行思考。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '16.无论对错我们都有机会自己进行判断。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '17.即便我们的建议并不实际或不一定有用，老师也会认真对待。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '18.老师不介意学生偏离其所教的内容去尝试自己的想法。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '19.老师鼓励我们遭受挫折时，把挫折看作学习的一部分。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '20.老师给我们布置开放性的问题，让我们自己去寻求答案。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '21.老师期望我们在小组活动中主动合作。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '22.尽管以不同的方式做事要占用更多的时间，老师还是鼓励我们这么做。 ',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '23.老师耐心倾听我们提出的幼稚可笑的问题。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '24.老师鼓励我们遭遇失败时，寻求其他可能的解决办法。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
        ],
        [
          {
            type: 3,
            title: '学生基本信息'
          },
          {
            type: 2,
            headline: '1．你的性别是：',
            value: [ '男', '女' ]
          },
          {
            type: 2,
            headline: '2．你是否是独生子女：',
            value: [ '是', '不是' ]
          },
          {
            type: 4,
            title: '3. 你父母接受教育的程度：',
            value: [
              {
                type: 2,
                headline: '（1）父亲接受教育的程度',
                value: [ '初中及以下教育', '高中教育', '大学教育', '大学以上教育', '不清楚' ]
              },
              {
                type: 2,
                headline: '（2）母亲接受教育的程度',
                value: [ '初中及以下教育', '高中教育', '大学教育', '大学以上教育', '不清楚' ]
              }
            ]
          },
          {
            type: 4,
            title: '4．关于希望接受教育的程度：',
            value: [
              {
                type: 2,
                headline: '（1）你希望自己接受教育的程度',
                value: [ '高中教育', '大学教育', '大学以上教育', '不清楚' ]
              },
              {
                type: 2,
                headline: '（2）父母希望你接受教育的程度',
                value: [ '高中教育', '大学教育', '大学以上教育', '不清楚' ]
              }
            ]
          },
          {
            type: 4,
            title: '5.父母职业',
            value: [
              {
                type: 2,
                headline: '（1）你父亲当前的职业：',
                value: [ '农业劳动者，如农民、渔民、牧民等', '体力劳动者或普通工人，如一线劳动工人、服务员、搬运工人、公交售票员、环卫工人、小时工等', '技术工人，如电工、邮递员、秘书、职员、一般办公室员工等', '专业技术人员，如医生、律师、工程师、建筑师、护士、教师、记者、摄影师、飞行员、演员、军人、警察、运动员、银行工作人员、小型私企老板等', '中层干部、管理人员，如政府机关领导干部、国企或外企领导、律师等', '高级领导干部、高级知识分子，如市长、法院院长、县委书记、工程师、科学家、大学教授等', '不工作', '退休', '其他' ]
              },
              {
                type: 2,
                headline: '（2）你母亲当前的职业：',
                value: [ '农业劳动者，如农民、渔民、牧民等', '体力劳动者或普通工人，如一线劳动工人、服务员、搬运工人、公交售票员、环卫工人、小时工等', '技术工人，如电工、邮递员、秘书、职员、一般办公室员工等', '专业技术人员，如医生、律师、工程师、建筑师、护士、教师、记者、摄影师、飞行员、演员、军人、警察、运动员、银行工作人员、小型私企老板等', '中层干部、管理人员，如政府机关领导干部、国企或外企领导、律师等', '高级领导干部、高级知识分子，如市长、法院院长、县委书记、工程师、科学家、大学教授等', '不工作', '退休', '其他' ]
              }
            ]
          },
          {
            type: 4,
            title: '6.你/你家是否拥有：',
            value: [
              {
                type: 2,
                headline: '（1）安静的学习环境',
                value: [ '有', '无' ]
              },
              {
                type: 2,
                headline: '（2) 自己的独立房间',
                value: [ '有', '无' ]
              },
              {
                type: 2,
                headline: '（3）电脑 ',
                value: [ '有', '无' ]
              },
              {
                type: 2,
                headline: '（4）上网条件',
                value: [ '有', '无' ]
              },
              {
                type: 2,
                headline: '（5）自己的书柜或书架  ',
                value: [ '有', '无' ]
              },
              {
                type: 2,
                headline: '（6）钢琴、小提琴、古筝等乐器',
                value: [ '有', '无' ]
              },
              {
                type: 2,
                headline: '（7）轿车或货车',
                value: [ '有', '无' ]
              }
            ]
          },
          {
            type: 2,
            headline: '7.一年以来，你阅读课外书的数量约为：',
            value: [ '0本', '1-7本', '8-15本', '16本及以上' ]
          },
          {
            type: 2,
            headline: '8.你最喜欢的一种课外读物类型是',
            value: [ '漫画卡通', '中外文学名著', '科普读物', '武侠小说', '配套读本', '校园文学', '其他' ]
          },
          {
            type: 4,
            title: '9. 你的父母或监护人（长期与你一起生活的长辈）会不会与你做下列的事情？',
            value: [
              {
                type: 2,
                headline: '（1）谈论我的学习',
                value: [ '从不或几乎没有', '每年一次或两次', '每月一次或两次', '每周一次或两次', '每天或几乎每天' ]
              },
              {
                type: 2,
                headline: '（2）谈论我的生活',
                value: [ '从不或几乎没有', '每年一次或两次', '每月一次或两次', '每周一次或两次', '每天或几乎每天' ]
              },
              {
                type: 2,
                headline: '（3）谈论我的心事与烦恼',
                value: [ '从不或几乎没有', '每年一次或两次', '每月一次或两次', '每周一次或两次', '每天或几乎每天' ]
              },
              {
                type: 2,
                headline: '（4）一起吃晚饭',
                value: [ '从不或几乎没有', '每年一次或两次', '每月一次或两次', '每周一次或两次', '每天或几乎每天' ]
              },
              {
                type: 2,
                headline: '（5）辅导做作业',
                value: [ '从不或几乎没有', '每年一次或两次', '每月一次或两次', '每周一次或两次', '每天或几乎每天' ]
              },
              {
                type: 2,
                headline: '（6）推荐科学读物',
                value: [ '从不或几乎没有', '每年一次或两次', '每月一次或两次', '每周一次或两次', '每天或几乎每天' ]
              }
            ]
          }
        ]
      ]
    }
  },
}
</script>
<style lang="less">
</style>
